export enum TariffType {
  A = 'A',
  B = 'B',
  C = 'C',
}
